export const assessments = {
  verifiers: "Verifiers",
  favorite_assessments: "Favorite assessments",
  creation: {
    assessment_created: "Assessment has been created successfully.",
    assessment_is_being_created:
      "Your assessment is currently being created. Please wait a moment while we complete the process.",
    confirmation_modal: {
      title_with_warnings: "Some sites won't inherit data",
      title_without_warnings: "Create Assessment",
      description_with_warnings:
        "You have selected a previous assessment as a starting point, but the sites will not inherit all of the data because you are missing some standards.",
      sites_warning_subtitle: "The following sites will inherit partial data from the previous assessment:",
      continue_confirmation: "Do you want to continue creating the assessment anyway?",
      create_anyway: "Create Anyway",
    },
  },
  verification: {
    verification_cannot_be_undone: "Once verified, this action cannot be undone",
    assessment_verification: "Assessment verification",
    verifies_this_assessment_on_behalf_of: "verifies this assessment on behalf of:",
    verified_this_assessment: "verified this assessment",
    verifies_this_assessment: "verifies this assessment",
    date_of_verification: "Date of when the verification was carried out",
    please_enter_verifier: "Please enter the verifier",
    send_verification: "Send Verification",
    verifier: "Verifier",
  },
  approval: {
    date_of_approval: "Date of the approval",
  },
  related_questions: "Related Questions",
  data_providers_assign: {
    override_warning: "Existing data provider assignments will be overridden.",
    data_provider_overview: "Data providers overview",
  },
  complete_assessment: {
    action: "Complete assessment",
    confirm_completion: "Confirm assessment completion",
    upload_additional_files_to_sites: "Upload additional files to sites",
    upload_file_here: "Please upload a file here to confirm assessment completion.",
    files_assigned_to_whole_assessment: "Files assigned to whole assessment",
    i_am_aware_that_i_cannot_undo_this_action:
      "I am aware that once I decide to complete the assessment, it cannot be undone. This process is irreversible.",
    assessment_completion_confirmation:
      "The assessment has been successfully completed. You can find it under the 'Completed Assessment' tab.",
  },
  previous_assessment: {
    label: "Previous assessment (optional)",
    description:
      "You can select a previous assessment as a starting point for your new one. Sites from the selected assessment will be highlighted with an icon in the dropdown below, and all applicable data will be copied to your new assessment. <a>Learn more</a>",
  },
  starting_point: "Assessment starting point",
  reviewers_overview: "Reviewers overview",
  back_to_overview: "Back to overview",
  site_assessment_progress: "Site assessment progress",
  Active_assessments: "Active assessments",
  Completed_assessments: "Completed assessments",
  add_a_comment: "Add a comment",
  Add_evidence: "Add evidence",
  Add_external_verification: "Add external verification step",
  Add_Step: "Add review step",
  approval_cannot_be_undone: "Once approved, this action cannot be undone",
  "After_approval,_You_can't_undo_approval": "After approval, You can't undo approval.",
  All_assessments: "All assessments",
  All_Sites: "All sites",
  all_sites_description:
    "Any changes you make to the standard selection here will be applied to all the sites you selected for this assessment.",
  Applicability: "Applicability",
  Approve: "Approve",
  approved_this_assessment: "approved this assessment",
  Approver: "Approver",
  approves_this_assessment: "approves this assessment",
  approves_this_assessment_on_behalf_of: "approves this assessment on behalf of:",
  archive_assessment_confirmation:
    "Are you sure? Once deleted, this assessment and all related data—including reports—will no longer be accessible.",
  areas_of_improvement: "Areas of improvement",
  Assessment_approval: "Assessment approval",
  Assessment_comment_overview: "Assessment comment overview",
  Assessment_list: "Assessment list",
  assessment_name: "Assessment name",
  assessment_of_conformity: "Assessment of conformity",
  Assessment_report: "Assessment report",
  Assessment_standard_setup: "Assessment standard setup",
  Assessment_update: "Assessment update",
  assessmentDetails: "Assessment details",
  Assessments: "Assessments",
  assign_data_providers: "Assign Data Providers",
  Assign_data_providers_to_selected_themes: "Assign data providers to selected themes",
  assign_reviewers: {
    "After_confirmation,_this_assigment_will_be_deleted": "After confirmation, this assigment will be deleted.",
    After_you_confirm_the_section:
      "You can assign reviewers and groups of reviewers to individual themes for each stage of review your assessment has.",
    Assign_Reviewers: "Assign Reviewers",
    Assign_Reviewers_to_the_Theme: "Assign Reviewers to the selected theme(s)",
    Assign_to_selected: "Assign to selected",
    Assign_Verifiers: "Assign Verifiers",
    Assign_Verifiers_to_an_assessment: "Assign Verifiers to an assessment",
    Assigned_Themes: "Assigned Themes",
    Delete_assigment: "Delete assigment",
    Select_Reviewer_for_each_theme: "Assign Reviewers for each theme or theme group",
    Selected_Theme: "Selected Theme",
    Step_stepNumber_External_Verification: "Step {{stepNumber}}: External Verification",
    There_are_no_assigned_themes: "There are no assigned themes.",
    There_are_no_unassigned_themes: "There are no unassigned themes.",
    Unassigned_Themes: "Unassigned Themes",
    Use_this_window_to_assign_multiply_reviewers_to_selected_themes:
      "Use this window to assign reviewer(s) to the selected theme(s).",
    Verifiers: "Verifiers",
    View_assessment: "View assessment",
  },
  assign_themes_description:
    "After assigning themes, the data providers will be tasked with filling out assessment\n          responses for their assigned theme(s). Not all themes need to be assigned in order to\n          proceed, but a theme must be assigned in order for the assessment of its related\n          requirements to proceed.",
  assign_themes_header: "Assign data provider for each theme",
  Assigned_Corporate_Coordinator: "Assigned Corporate Coordinator",
  assigned_themes: "Assigned themes",
  associated_requirements: "Associated requirements",
  click_to_select: "Click to select files from your computer or drag and drop.",
  Closing_steps: "Closing steps",
  Comment: "Comment",
  Comment_and_evidence: "Comment and evidence",
  comments: "Comments",
  Conformity_assessment: "Conformity assessment",
  conformity_description:
    "Conformity refers to the fulfillment of a requirement, and may require evidence to demonstrate both process and implementation, depending on the stated expectation.",
  Conformity_level: "Conformity level",
  Conformity_level_description:
    "Conformity level measures compliance with a standard in terms of performance and quality. It is used to ensure specific quality, safety, or regulatory criteria are met for a product, service, or process.",
  copy_answer: {
    confirmation: "Copying this data will result in the overwrite of any existing draft data.",
    Filter: "Filter",
    site: "Site",
    status: "Status",
  },
  Copy_this: "Copy this",
  clarifying_notes: "Clarifying notes",
  Corporate_coordinator_assigned: "Corporate Coordinator assigned to this assessment",
  corporate_guidance: "Corporate Guidance",
  Country: "Country",
  Create_assessment: "Create Assessment",
  Critical: "Critical",
  Data_Provider_Assignment: "Data Provider Assignment",
  Data_providers: "Data providers",
  Data_providers_overview: "Data providers overview",
  Default_View: "Default View",
  Delete_evidence: "Delete evidence",
  Delete_evidence_confirmation_message: "After confirmation, this evidence will be deleted from this protocol.",
  delete_evidences_description: "After confirmation, this evidence will be deleted from this protocol.",
  Delete_requirement: "Delete requirement",
  Description: "Description",
  Due_date: "Due date",
  edit_assessment: "Edit assessment",
  Edited_by: "Edited by",
  erm_mapping_note: "ERM Mapping Note",
  Evidence_files: "Evidence files",
  evidences: "Evidence",
  External_Verification: "External Verification",
  External_verifiers_can_see_comments: "External verifiers can see comments.",
  External_verifiers_have_been_added_and_they_can_read_comments_made_from_this_point_forward:
    "External verifiers have been added and they can read comments made from this point forward.",
  File: "File",
  File_upload_error: "File upload error",
  Fill_in_Assessment_Details: "Fill in Assessment Details",
  Filter_by_site: "Filter by site",
  Filter_by_status: "Filter by status",
  Filters: "Filters",
  ghost_question_warning:
    "This question is no longer valid for this assessment due to the recent protocol update. Please <docsLink>click here</docsLink> to read our documentation and learn more about the protocol and its update.",
  Go_back_to_assessments: "Go back to assessments",
  informative: "Informative",
  internal_audit_awareness:
    "I am aware that internal audit or assessment process is connected to the associated requirements. *",
  Last_edited: "Last edited",
  make_change_protocol_confirm: "Are you sure you want to publish the changes?",
  make_change_protocol_confirm_description:
    "Consider leaving a comment to provide context for other users regarding the changes you have made.",
  Modify_responses: "Modify responses",
  Needs_review: "Needs review",
  Next_to_review: "Next to review",
  No_assessments_match_the_search_criteria: "No assessments match the search criteria.",
  no_assigned_themes: "There are no assigned themes.",
  No_data_provider_assigned: "No data provider assigned",
  No_more_Protocol_Questions_to_review_at_the_moment: "No more Protocol Questions to review at the moment.",
  no_reviewers_assigned: "No reviewers assigned",
  no_reviewer_assignments: "No reviewer assignments to display",
  no_unassigned_themes: "There are no unassigned themes.",
  normative: "Normative",
  Notice: "Notice",
  on_behalf_of: "on behalf of:",
  Please_enter_a_comment: "Please enter a comment",
  Please_enter_the_approver: "Please enter the approver",
  Please_select_at_least_one_standard:
    "You must have at least one standard for each site selected. Please go back and deselect a site if you do not wish to assess it.",
  Please_upload_a_file_here_to_confirm_approval_from_your_superior:
    "Please upload a file here to confirm approval from your superior",
  Previous: "Previous",
  Publish_changes: "Publish changes",
  Question_status: "Question status",
  Reference: "Reference",
  Reference_data: "Reference data",
  release_drop: "Release to drop the files here.",
  Report_link: "Report link",
  reset_default_all_description:
    "Any changes you make to the standard selection here will be applied to all the sites you selected for this assessment.",
  Review_steps: "Review steps",
  Reviewed_by: "Reviewed by",
  reviewer_assignment_not_available_as_no_assingments_made_yet:
    "Reviewer assignment overview is not available yet as no assignments have been made yet.",
  Reviewers: "Reviewers",
  Role: "Role",
  Search_assessment_by_site_name_or_assessment_name: "Search assessment by site name or assessment name",
  Search_standard_by_name: "Search standard by name",
  Select_data_providers: "Select data providers",
  self_assessment_rating: {
    does_not_meat: "Does not meet",
    fully_meets: "Fully meets",
    not_applicable: "Not applicable",
    partially_meets: "Partially meets",
    substantially_meets: "Substantially meets",
  },
  Self_assessment_steps: "Self assessment - steps",
  "Self-assessment": "Self-assessment",
  Send_Approval: "Send Approval",
  Site: "Site",
  Site_coordinator: "Site coordinator",
  Site_coordinators: "Site coordinators",
  Site_List: "Site List",
  Site_name: "Site name",
  site_setup: "{{siteName}} setup",
  Sites: "Sites",
  Staff_and_dates_setup: "Staff and dates setup",
  stakeholders_awareness:
    "I am aware that stakeholders engagement is required to implement the associated requirements. *",
  standard_guidance: "Standard Guidance",
  "Standards_not_included_in_this_assessment_will appear_grayed-out_To_view_other_standards":
    "Standards not included in this assessment will appear grayed-out. To view other standards mapped to this Protocol Question, click on the 'View' icon.",
  "Standards_not_included_in_this_assessment_will_appear_grayed-out":
    "Standards not included in this assessment will appear grayed-out.",
  status: {
    all_questions: "All Questions",
    answered: "Answered",
    assigned_to_me: "Assigned to me",
    declined: "Declined",
    in_draft: "In draft",
    in_review: "In review",
    not_answered: "Not Answered",
    reviewed: "Reviewed",
    unassigned: "Unassigned",
  },
  Step: "Step",
  Step_1_Data_Provider_Assignment: "Step 1: Data Provider Assignment",
  "Step_2_Self-assessment": "Step 2: Self-assessment",
  submit_for_review: "Submit for review",
  sumbit_protocol_confirm: "Submit protocol question for review",
  sumbit_protocol_confirm_description: "After confirmation, this protocol question will be sent for review.",
  tasks_comparison: {
    areas_of_improvement: " Areas of improvement",
    assessment_of_conformity: "Assessment of conformity",
    Back_to_the_assessment_list: "Back to the Assessment list",
    Comparison_view: "Comparison view",
    conformity_level: "Conformity level",
    evidences: "Evidences",
    field_name: "Field name",
  },
  taskstatus: {
    declined: "This Protocol Question is declined.",
    in_review: "This Protocol Question has been submitted for the next round of review.",
    reviewed: "This Protocol Question is reviewed.",
    not_submitted_for_review: "This Protocol Question has not yet been submitted for review.",
    unassigned: "This Protocol Question has not been assigned to anyone yet.",
  },
  The_standards_you_select_impact_the_themes:
    "Only the standards selected in the site setup are made available for customization.",
  Themes_are_not_assigned_yet:
    "Data Providers have not yet been assigned. The Site Coordinator should assign Data Providers for each theme before proceeding.",
  There_are_currently_no_questions_that_are_available_for_this_Site:
    "There are currently no questions that are available for this Site.",
  There_are_no_assessments: "There are no assessments.",
  This_is_a_Critical_requirement:
    "This is a Critical Requirement set by the IRMA Board for gaining any Achievement Level in the IRMA System.",
  This_is_data_provide_view: "Data Provider view",
  This_is_review_view: "Reviewer view",
  Type_here_to_add_description: "Type here to add description",
  unassigned_themes: "Unassigned themes",
  update_assessment: "Update assessment",
  Upload_an_evidence: "Upload an evidence",
  Upload_evidence: "Upload evidence",
  Verifiers: "Verifiers",
  Verifiers_have_access_to_comments_that_are_made_after_they_are_assigned:
    "Verifiers have access to comments that are made after they are assigned.They cannot access comments made before assignment.",
  approved: "Approved",
  verified: "Verified",
  verify: "Verify",
  view_assessment: "View assessment",
  View_conversation: "View conversation",
  View_conversation_another_comments: "View conversation (+{{another_comments}})",
  You_can_reorder_reviewers_using_drag_and_drop: "You can reorder reviewers using drag and drop",
  means_of_verification: "Means of verification",
  evidence_examples: "Evidence examples",
  "You_can’t_deselect_a_site": "You can’t deselect a site.",
  "Your_changes_are_not_auto-saved_Click_the_Publish_Changes_button_to_save_and_publish_your_changes":
    "Your changes are not auto-saved. Click the 'Publish Changes' button to save and publish your changes.",
  "Your_standard_setup_cannot_be_updated_as_your_assessment_isn't_employing_the_latest_protocol_set":
    "Your standard setup cannot be updated as your assessment isn't employing the latest protocol set. Please reach out to the ERM Support Team for assistance.",
  theme_progress: {
    title: "Theme Progress",
    site_assessment_label: "Site Assessment",
    all_site_assessments: "All Site Assessments",
    no_data: "No theme data available",
    axis_labels: {
      themes: "Themes",
      task_count: "Task Count",
    },
    status: {
      unassigned: "Unassigned",
      in_draft_unanswered: "In Draft Unanswered",
      in_draft_answered: "In Draft Answered",
      declined: "Declined",
      in_review: "In Review",
      reviewed: "Reviewed",
    },
  },
} as const;
